import styled from '@emotion/styled';

export const LabelStyled = styled.span`
  display: flex;
  align-items: center;
`;
